import { ServiceIncludesItem, ServiceIncludesList } from '~/src/components/TariffCard/styled';

interface IAdvProps {
    advantages: Array<string>,
}

const AdvantagesList = ({ advantages }: IAdvProps): JSX.Element => {
    return (
        <ServiceIncludesList>
            {advantages.map((advantage, index) => (
                <ServiceIncludesItem
                    key={index}
                    dangerouslySetInnerHTML={{ __html: advantage }}
                    data-test='adv-item'
                />
            ))}
        </ServiceIncludesList>
    );
};

export default AdvantagesList;
